import { MutationTree } from 'vuex';
import { REGLEMENT_FOURNISSEUR } from './mutation-types';
import { initialState as resetState, ReglementFournisseurState } from './state';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { ReglementDTO } from '@/models/ReglementDTO';

export const mutations: MutationTree<ReglementFournisseurState> = {

    [REGLEMENT_FOURNISSEUR.SET_REGLEMENTS](state, reglements: ReglementDTO[]) {
        state.reglements = reglements;
    },
    [REGLEMENT_FOURNISSEUR.ADD_REGLEMENTS](state, reglements: ReglementDTO[]) {
        state.reglements = [...state.reglements, ...reglements];
    },
    [REGLEMENT_FOURNISSEUR.RESET_ITEMS](state) {
        Object.assign(state, resetState);
    },
    [REGLEMENT_FOURNISSEUR.SET_FILTER_OPERATEUR](state, operateur: string) {
        state.filtreOperateur = operateur;
    },
    [REGLEMENT_FOURNISSEUR.SET_FILTER_MONTANT](state, montant: number) {
        state.filtreMontant = montant;
    },
    [REGLEMENT_FOURNISSEUR.SET_FILTER_DATE_DEBUT](state, dateDebut: string) {
        state.filtreDateDebut = dateDebut;
    },
    [REGLEMENT_FOURNISSEUR.SET_FILTER_DATE_FIN](state, dateFin: string) {
        state.filtreDateFin = dateFin;
    },
    [REGLEMENT_FOURNISSEUR.SET_REGLEMENTS_LOADING](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [REGLEMENT_FOURNISSEUR.SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        const tableHeader = state.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return[...newTable, headerItem];
        }, [] as TableHeader[]);
        state.tableHeader = tableHeader;
        state.sort = sort;
    },
    [REGLEMENT_FOURNISSEUR.SET_NUMBER_OF_PAGES](state, nbOfPages: number) {
        state.numberOfPage = nbOfPages;
    },
    [REGLEMENT_FOURNISSEUR.SET_PAGE](state, page: number) {
        state.page = page;
    },
    [REGLEMENT_FOURNISSEUR.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },
    [REGLEMENT_FOURNISSEUR.SET_NB_ELEMENTS](state, nb: number) {
        state.count = nb;
    },
    [REGLEMENT_FOURNISSEUR.XLS_LOADING](state, isLoading: boolean) {
        state.isXlsLoading = isLoading;
    },
};
